export interface SkeletonProps {
  variant?: 'text' | 'card' | 'circle';
  width?: string | number;
  height?: string | number;
  className?: string;
  lines?: number;
}

export function Skeleton({
  variant = 'text',
  width,
  height,
  className = '',
  lines = 1,
}: SkeletonProps) {
  const baseClasses = 'animate-pulse bg-bg-hover rounded-sm';

  if (variant === 'circle') {
    return (
      <div
        className={`${baseClasses} rounded-full ${className}`}
        style={{ width: width || '40px', height: height || '40px' }}
      />
    );
  }

  if (variant === 'card') {
    return (
      <div
        className={`${baseClasses} rounded-md ${className}`}
        style={{ width: width || '100%', height: height || '200px' }}
      />
    );
  }

  // Text variant with multiple lines support
  if (lines > 1) {
    return (
      <div className={`space-y-2 ${className}`}>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={baseClasses}
            style={{
              width: index === lines - 1 ? '75%' : '100%',
              height: height || '1rem',
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={`${baseClasses} ${className}`}
      style={{ width: width || '100%', height: height || '1rem' }}
    />
  );
}
